<template>
  <div class="segments-module-wrappers ion-no-padding">
    <div v-if="loadingBroadcastDetails" class="loading-overlay">
      <VProgressRing connotation="cta" />
      <span>Loading broadcast details...</span>
    </div>

    <div :key="`wrapper-${conditionGroups.length}`">
      <div class="segment-list-wrapper">
        <div v-if="loadingPrerequisite" class="segments-loader">
          <VProgressRing connotation="cta" :size="-4" />
           Loading...
        </div>
        <template v-for="(group, gIndex) in conditionGroups" :key="`group-${gIndex}`">
          <div v-if="!isHiddenConditionGroup(group)" class="group segment-filter-section" :draggable="!isDefaultCondition(group, gIndex)" :class="{ singleItem: getVisibleConditionsCount(group) == 1 }" @drop="onDropGroup($event, group, gIndex)" @dragover.prevent @dragstart="startDragGroup($event, gIndex, cIndex)">
            <template v-for="(thisCondition, cIndex) in group" :key="`condition-${gIndex}-${cIndex}-${thisCondition.condition_type || 'unknown'}`">
              <div v-if="[CONDITION_TYPE.DLR_STATUS].includes(thisCondition.condition_type)" :class="{ dragOver: cIndex == dropIndex, lastRow: cIndex == group.length - 1 }" :draggable="!isDefaultCondition(group, gIndex)" @drop="onDropItem($event, gIndex, cIndex)" @dragstart="startDragItem($event, gIndex, cIndex)" @dragover.prevent @dragenter="onDragEnter($event, cIndex)">
                <div class="segment-row marginBottom">
                  <div class="segment-name hasItem">
                    <span>{{ thisCondition.condition_type }}</span>
                  </div>
                  <VIcon v-if="!(cIndex == 0 &&  thisCondition.condition_type == CONDITION_TYPE.INTERACTED_WITH_CHANNEL) && CONDITION_TYPE.INTERACTION_CHANNEL_PAGE_ID != thisCondition.condition_type && CONDITION_TYPE.MARKETING_OPT_IN_STATE != thisCondition.condition_type" @click="!isViewOnlyMode && removeCondition($event, gIndex, cIndex)" name="delete-line" connotation="alert" :class="{ 'icon-disabled': isViewOnlyMode }" class="trashIcon cursorPointer"></VIcon>
                </div>
                <div class="segment-row marginBottom">
                  <div class="segment-title broadcast-value">
                    <!-- Searchable Broadcast Dropdown -->
                    <div class="broadcast-search-dropdown" ref="broadcastDropdownRef">
                      <VTextField appearance="ghost"
                        v-model="thisCondition.broadcastSearchTerm"
                        @input="() => onBroadcastSearch(thisCondition)"
                        placeholder="Search Broadcast by name"
                        :disabled="isViewOnlyMode"
                        class="vivid-input"
                      ></VTextField>
                      <div v-if="thisCondition.showBroadcastDropdown" class="broadcast-dropdown-list">
                        <div v-if="thisCondition.broadcastSearchLoading" class="broadcast-dropdown-item loading">
                          <VProgressRing connotation="cta" :size="-5" /> Loading...
                        </div>
                        <div v-else-if="!thisCondition.broadcastSearchResults?.length" class="broadcast-dropdown-item empty">
                          No broadcasts found
                        </div>
                        <div v-else v-for="item in thisCondition.broadcastSearchResults" :key="item.value" class="broadcast-dropdown-item" @click="onSelectBroadcast(item, thisCondition)">
                          {{ item.title }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="static-condition">
                    <span> {{ thisCondition.staticOperator }} </span>
                  </div>
                  <div class="segment-title segment-value">
                    <SelectDropDownV2
                      :modelValue="thisCondition.statuses || []"
                      :options="selectStatus.map(s => ({ value: s.id, title: s.value }))"
                      placeholder="Select status"
                      :isMultiSelect="true"
                      :isSelectAllEnabled="false"
                      :isDisabled="isViewOnlyMode"
                      :enableSearch="false"
                      @change="(data) => { thisCondition.statuses = data.selectedValues; updateDLRCondition(thisCondition); }"
                    />
                  </div>
                </div>
              </div>
              <div v-else-if="[CONDITION_TYPE.BROADCAST_INTERACTION_STATUS].includes(thisCondition.condition_type)" :class="{ dragOver: cIndex == dropIndex, lastRow: cIndex == group.length - 1 }" :draggable="!isDefaultCondition(group, gIndex)" @drop="onDropItem($event, gIndex, cIndex)" @dragstart="startDragItem($event, gIndex, cIndex)" @dragover.prevent @dragenter="onDragEnter($event, cIndex)">
                <div class="segment-row marginBottom">
                  <div class="segment-name hasItem">
                    <span>{{ thisCondition.condition_type }}</span>
                  </div>
                  <VIcon v-if="!(cIndex == 0 &&  thisCondition.condition_type == CONDITION_TYPE.INTERACTED_WITH_CHANNEL) && CONDITION_TYPE.INTERACTION_CHANNEL_PAGE_ID != thisCondition.condition_type && CONDITION_TYPE.MARKETING_OPT_IN_STATE != thisCondition.condition_type" @click="!isViewOnlyMode && removeCondition($event, gIndex, cIndex)" name="delete-line" connotation="alert" :class="{ 'icon-disabled': isViewOnlyMode }" class="trashIcon cursorPointer"></VIcon>
                </div>
                <div class="segment-row marginBottom">
                  <div class="segment-title broadcast-value">
                    <!-- Searchable Broadcast Dropdown -->
                    <div class="broadcast-search-dropdown" ref="broadcastDropdownRef">
                      <VTextField appearance="ghost"
                        v-model="thisCondition.broadcastSearchTerm"
                        @input="() => onBroadcastSearch(thisCondition)"
                        placeholder="Search Broadcast by name"
                        :disabled="isViewOnlyMode"
                        class="vivid-input"
                      ></VTextField>
                      <div v-if="thisCondition.showBroadcastDropdown" class="broadcast-dropdown-list">
                        <div v-if="thisCondition.broadcastSearchLoading" class="broadcast-dropdown-item loading">
                          <VProgressRing connotation="cta" :size="-5" /> Loading...
                        </div>
                        <div v-else-if="!thisCondition.broadcastSearchResults?.length" class="broadcast-dropdown-item empty">
                          No broadcasts found
                        </div>
                        <div v-else v-for="item in thisCondition.broadcastSearchResults" :key="item.value" class="broadcast-dropdown-item" @click="onSelectBroadcast(item, thisCondition)">
                          {{ item.title }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="segment-title segment-value">
                    <SelectDropDownV2
                      :modelValue="thisCondition.selectedElements || []"
                      :options="(thisCondition.broadcastElements || []).map(el => ({ value: el.id, title: el.title || `Element ${el.id}` }))"
                      placeholder="Select element"
                      :isMultiSelect="true"
                      :isSelectAllEnabled="false"
                      :isDisabled="isViewOnlyMode || !thisCondition.broadcastElements?.length"
                      :enableSearch="false"
                      @change="(data) => { thisCondition.selectedElements = data.selectedValues; thisCondition.selectedButtons = []; updateAvailableButtons(thisCondition); }"
                    />
                  </div>
                  <div class="segment-title segment-value">
                    <SelectDropDownV2
                      :modelValue="thisCondition.selectedButtons || []"
                      :options="(thisCondition.availableButtons || []).map(btn => ({ value: btn.id, title: btn.title || btn.description || `Button ${btn.id}` }))"
                      placeholder="Select button IDs"
                      :isMultiSelect="true"
                      :isSelectAllEnabled="false"
                      :isDisabled="isViewOnlyMode || !thisCondition.selectedElements?.length || !thisCondition.availableButtons?.length"
                      :enableSearch="false"
                      @change="(data) => { thisCondition.selectedButtons = data.selectedValues; updateBroadcastInteractionCondition(thisCondition); }"
                    />
                  </div>
                </div>
              </div>
              <!-- Disabled on UI (segments + broadcast): keep condition support in query/parser, but don't render it -->
              <div class="segment-row" v-else-if="thisCondition.condition_type != CONDITION_TYPE.INTERACTION_CHANNEL_PAGE_ID" :class="{ dragOver: cIndex == dropIndex, lastRow: cIndex == group.length - 1 }" :draggable="!isDefaultCondition(group, gIndex)" @drop="onDropItem($event, gIndex, cIndex)" @dragstart="startDragItem($event, gIndex, cIndex)" @dragover.prevent @dragenter="onDragEnter($event, cIndex)">
                <div size="2" class="segment-name">
                   <span>{{ thisCondition.condition_type }}</span>
                </div>
                <template v-if="[CONDITION_TYPE.INTERACTION_DATE, CONDITION_TYPE.LAST_REPLY_DATE].includes(thisCondition.condition_type)">
                  <div class="date-time-dropdown">
                    <VSelect aria-label="condition" class="vivid-select" :interface-options="{ cssClass: 'selectOptionsSegment', header: 'Select Data Filter' }" v-model="thisCondition.operator" :disabled="isViewOnlyMode">
                      <VOption value="=" text="on"></VOption>
                      <VOption value="<" text="before"></VOption>
                      <VOption value=">" text="after"></VOption>
                    </VSelect>
                  </div>
                </template>

                <template v-else-if="[CONDITION_TYPE.INTERACTION_TIME].includes(thisCondition.condition_type)">
                  <div class="date-time-dropdown">
                    <VSelect  aria-label="condition" class="vivid-select" :interface-options="{ cssClass: 'selectOptionsSegment', header: 'Select Data Filter' }" v-model="thisCondition.operator" :disabled="isViewOnlyMode">
                      <VOption value="<" text="before"></VOption>
                      <VOption value=">" text="after"></VOption>
                    </VSelect>
                  </div>
                </template>

                <template v-else-if="[CONDITION_TYPE.TAGS].includes(thisCondition.condition_type)">
                  <div class="date-time-dropdown">
                    <VSelect appearance="ghost" fixed-dropdown :disabled="isViewOnlyMode" aria-label="condition" class="vivid-select" :interface-options="{ cssClass: 'selectOptionsSegment', header: 'Select Data Filter' }" v-model="thisCondition.operator">
                      <VOption value="in unnest" text="is"></VOption>
                      <VOption value="not in unnest" text="isn't"></VOption>
                    </VSelect>
                  </div>
                </template>

                <template v-else-if="[CONDITION_TYPE.INTERACTION_CHANNEL, CONDITION_TYPE.INTERACTED_WITH_CHANNEL, CONDITION_TYPE.INTERACTION_CHANNEL_PAGE_ID, CONDITION_TYPE.INTERACTED_WITH_BOT, CONDITION_TYPE.ENGAGED_WITH_BOT_FLOW, CONDITION_TYPE.GENDER, CONDITION_TYPE.DLR_STATUS, CONDITION_TYPE.BROADCAST_INTERACTION_STATUS, CONDITION_TYPE.MARKETING_OPT_IN_STATE].includes(thisCondition.condition_type)">
                  <div class="static-condition">
                    <span> {{ thisCondition.staticOperator }} </span>
                  </div>
                </template>

                <div v-else-if="[CONDITION_TYPE.NAME, CONDITION_TYPE.EMAIL].includes(thisCondition.condition_type)">
                  <VSelect appearance="ghost" fixed-dropdown :disabled="isViewOnlyMode" v-model="thisCondition.operator" aria-label="condition" class="vivid-select">
                    <VOption value="=" text="is"></VOption>
                    <VOption value="!=" text="isn't"></VOption>
                    <VOption value="is null" text="is unknown"></VOption>
                  </VSelect>
                </div>

                <div class="segment-title segment-value">
                  <template v-if="[CONDITION_TYPE.INTERACTION_DATE].includes(thisCondition.condition_type)"> 
                    <DateTime id="customer-segments-v2-interaction-date" :maxValidation="{ enabled: true }" v-model="thisCondition.value" :disabled="isViewOnlyMode" format="YYYY-MM-DD" :presentation="thisCondition.condition_type == CONDITION_TYPE.INTERACTION_TIME ? 'date-time' : 'date'" class="date-time"></DateTime>
                  </template>

                  <template v-else-if="[CONDITION_TYPE.LAST_REPLY_DATE].includes(thisCondition.condition_type)"> 
                    <DateTime id="customer-segments-v2-last-reply-date" :maxValidation="{ enabled: true }" v-model="thisCondition.value" :disabled="isViewOnlyMode" format="YYYY-MM-DD" presentation="date" class="date-time"></DateTime>
                  </template>

                  <template v-else-if="[CONDITION_TYPE.INTERACTION_TIME].includes(thisCondition.condition_type)">
                    <DateTime id="customer-segments-v2-interaction-time-datetime" :maxValidation="{ enabled: true }" v-model="thisCondition.value" :disabled="isViewOnlyMode" format="YYYY-MM-DD HH:mm:ss" class="date-time"></DateTime>
                  </template>

                  <!-- <template v-else-if="[CONDITION_TYPE.INTERACTED_WITH_CHANNEL, CONDITION_TYPE.INTERACTION_CHANNEL].includes(thisCondition.condition_type)">
                    <VSelect appearance="ghost" fixed-dropdown placeholder="Select Channel" v-model="thisCondition.value">
                      <VOption v-for="(channel, index) in socialChannels" :key="index" :value="channel.id" :text="channel.value"></VOption>
                    </VSelect>
                  </template> -->

                  <template v-else-if="CONDITION_TYPE.TALKED_WITH_AGENT == thisCondition.condition_type">
                    <VSelect appearance="ghost" fixed-dropdown :disabled="isViewOnlyMode" fill="outline" aria-label="agent" placeholder="Select Agent" class="vivid-select" v-model="thisCondition.value">
                      <VOption v-for="agent in agents" :key="agent.id" :value="agent.id" :text="agent.value"></VOption>
                    </VSelect>
                  </template>

                  <template v-else-if="[CONDITION_TYPE.INTERACTED_WITH_BOT, CONDITION_TYPE.ENGAGED_WITH_BOT_FLOW].includes(thisCondition.condition_type)">
                    <VSelect appearance="ghost" fixed-dropdown fill="outline" aria-label="bots"  placeholder="Select Bot" class="vivid-select" v-model="thisCondition.value">
                      <VOption v-for="(bot, index) in allBots" :key="index" :value="bot.id.toString()" :text="bot.displayname"></VOption>
                    </VSelect>
                  </template>

                  <template v-else-if="[CONDITION_TYPE.NAME, CONDITION_TYPE.NUMBER, CONDITION_TYPE.EMAIL].includes(thisCondition.condition_type)">
                    <VTextField appearance="ghost" v-if="thisCondition.operator != 'is null'" v-model="thisCondition.value" :placeholder="CONDITION_TYPE.NUMBER === thisCondition.condition_type ? '+1 987654321 (Country code<SPACE>Number)' : 'Enter Value'" class="vivid-input w-100" maxlength="500" :readonly="isViewOnlyMode"></VTextField>
                    <VTextField appearance="ghost" v-else :disabled="true" placeholder="" class="vivid-input w-100" maxlength="500"></VTextField>
                  </template>

                  <template v-else-if="[CONDITION_TYPE.CUSTOM_FIELD].includes(thisCondition.condition_type)">
                    <CustomFieldInputKeyValue
                      v-model="thisCondition.value"
                      placeholder="Enter value"
                      :isDisabled="isViewOnlyMode"
                      :maxLength="240"
                      class="input-wrapper"
                    />
                  </template>

                  <template v-else-if="CONDITION_TYPE.GENDER == thisCondition.condition_type">
                    <VSelect appearance="ghost" fixed-dropdown fill="outline" aria-label="gender"  :disabled="isViewOnlyMode" :interface-options="{ cssClass: 'selectOptionsSegment' }" placeholder="Select gender" class="vivid-select w-100" v-model="thisCondition.value">
                      <VOption v-for="(personalItem, index) in gender" :key="index" :value="personalItem.value" :text="personalItem.value"></VOption>
                    </VSelect>
                  </template>

                  <template v-else-if="CONDITION_TYPE.MARKETING_OPT_IN_STATE == thisCondition.condition_type">
                    <SelectDropDownV2
                      :modelValue="thisCondition.statuses || []"
                      :options="marketingOptinStatus.map(item => ({ value: item.id, title: item.value }))"
                      placeholder="Select Marketing Opt-in Status"
                      :isMultiSelect="true"
                      :isSelectAllEnabled="false"
                      :isDisabled="isViewOnlyMode"
                      :enableSearch="false"
                      @change="(data) => { thisCondition.statuses = data.selectedValues; updateMarketingOptinStatusCondition(thisCondition); }"
                    />
                  </template>

                  <template v-else-if="CONDITION_TYPE.TAGS == thisCondition.condition_type">
                    <div class="full-width">
                      <selectDropDown
                        v-if="tags.length > 0"
                        :key="'tag-select-' + tags.length"
                        :options="tagOptions" 
                        :selectedValueProp="['null', null, undefined, 'undefined'].includes(thisCondition.value) ? '' : thisCondition.value"
                        placeholder="Select Tag"
                        :clientSideSearch="true"
                        @onSelectOption="(option) => { thisCondition.value = option.selectedValue}"
                        class="slctContainer full-width"
                      />
                      <!-- Loading/Error message if tags array is empty -->
                      <div v-if="tagsLoading" class="error-message">
                        Loading tags...
                      </div>
                      <div v-else-if="tags.length === 0" class="error-message">
                        No tags available.
                      </div>
                    </div>
                  </template>

                  <template v-else-if="CONDITION_TYPE.INTERACTED_WITH_CHANNEL == thisCondition.condition_type && mode == 'segment'">
                    <VSelect appearance="ghost" fixed-dropdown  fill="outline" aria-label="social_channels" :disabled="isViewOnlyMode" :interface-options="{ cssClass: 'selectOptionsSegment' }" placeholder="Select platform" class="vivid-select" v-model="thisCondition.value">
                      <VOption v-for="(platform, index) in socialChannels" :key="index" :value="platform.id" :text="platform.value"></VOption>
                    </VSelect>
                  </template>
                  
                  <div v-else class="segment-condition static-condition">
                    <span> {{ thisCondition.value }} </span>
                  </div>
                </div>

                <VIcon v-if="!(cIndex == 0 &&  thisCondition.condition_type == CONDITION_TYPE.INTERACTED_WITH_CHANNEL) && CONDITION_TYPE.INTERACTION_CHANNEL_PAGE_ID != thisCondition.condition_type && CONDITION_TYPE.MARKETING_OPT_IN_STATE != thisCondition.condition_type" @click="!isViewOnlyMode && removeCondition($event, gIndex, cIndex)" name="delete-line" connotation="alert" :class="{ 'icon-disabled': isViewOnlyMode }" class="trashIcon cursorPointer"></VIcon>
              </div>

              <div v-if="shouldShowOrDivider(group, cIndex)" class="row-divider">
                <div class="group-divider">
                  <span>OR</span>
                </div>
              </div>
            </template>

            <div class="btn-or-condition-wrapper flex-center cursorPointer" v-if="!isDefaultCondition(group, gIndex)" @click="onclickAddCondition($event, gIndex)">
              <button :disabled="loadingPrerequisite || isViewOnlyMode"  expand="full" class="btn-or-condition">
                <VIcon name="plus-line" connotation="cta" style="padding-right: 10px"></VIcon> OR Condition </button>
            </div>
          </div>

          <div v-if="shouldShowGroupDivider(gIndex)" class="group-divider"><span>AND</span> </div>
        </template>
      </div>
    </div>
    <div @click="onclickAddCondition($event, null)" class="btn-add-condition-wrapper flex-center cursorPointer">
      <button :disabled="loadingPrerequisite || isViewOnlyMode" expand="full" class="btn-add-condition">
        <VIcon name="plus-line" connotation="cta" style="padding-right: 10px"></VIcon> AND Condition </button>
    </div>
  </div>

  <!-- Note: CustomFieldInputKeyValue.vue now handles its own modal internally -->
</template>

<script>
import { CONDITION_TYPE, channels, KEY_CONDITION_TYPE_MAPPING, filterOperatorsMappingReverse } from "./segmentConstants.js";
import DateTime from "@/components/DateTime.vue";
import apiInterceptor from '@/shared/apiInterceptor';
import selectDropDown from '@/components/selectDropDown.vue';
import SelectDropDownV2 from '@/components/SelectDropDownV2.vue';
import CustomFieldInputKeyValue from '@/components/CustomFieldInputKeyValue.vue';
import { queryClient } from '@/shared/queryClient';
import { customerTagsQueryOptions } from '@/composables/useCustomerTags';
import { teamMembersQueryOptions } from '@/composables/useTeamMembers';
import { botsQueryOptions } from '@/composables/useBots';
import { useSocialConnections } from '@/composables/useSocialConnections';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { useUIStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';
import { environment } from '@/shared/env.js';

export default {
  setup() {
    const { connectedChannels } = useSocialConnections();
    const { socialPlatformConnectedArray } = useSocialChannels();
    return { connectedChannels, socialPlatformConnectedArray };
  },
  components: {
    DateTime,
    selectDropDown,
    SelectDropDownV2,
    CustomFieldInputKeyValue
  },
  emits: ['clickedOnAddCondition'],
  data() {
    return {
      loading: false,
      allTags: [],
      allAgents: [],
      allBots: [],
      filterConditions: "and", //or,
      interactionDate: { operator: undefined, date: undefined },
      interactionTime: { operator: undefined, time: undefined },
      conditions: [],
      tags: [],
      agents: [],
      CONDITION_TYPE,
      channels,
      socialChannels: [],
      gender: [
        { id: "male", value: "male" },
        { id: "female", value: "female" },
        { id: "others", value: "others" }
      ],
      marketingOptinStatus: [
        { id: 1, value: "Subscribed" },
        { id: 0, value: "No status" }
      ],
      selectStatus: [
        { id: "submitted", value: "Submitted" },
        { id: "delivered", value: "Delivered" },
        { id: "read", value: "Read" },
        { id: "undeliverable", value: "Undeliverable" },
        { id: "failed", value: "Failed" },
        { id: "rejected", value: "Rejected" }
      ],
      selectTemplateIds: [
        { id: "template_id1", value: "Template ID 1" },
        { id: "template_id2", value: "Template ID 2" }
      ],
      mode: "segment",
      dragIndex: null,
      dragGroupIndex: null,
      dragFromGroupIndex: null,
      dropIndex: null,
      droppingInLastGroup: false,
      prevDropIndex: null,
      conditionsBeforeDragDrop: null,
      conditionToDrop: null,
      query: ``,
      conditionGroups: [],
      loadingPrerequisite: false,
      groupIndexToAddCondition: null,
      tagsLoading: false,
      allBroadcastsData: [],
      selectedBroadcast: '',
      broadcastSearchTerm: '',
      broadcastSearchResults: [],
      showBroadcastDropdown: false,
      broadcastSearchLoading: false,
      broadcastSearchTimeout: null,
      broadcastDropdownRef: null,
      loadingBroadcastDetails: false,
    };
  },
  props: {
    editBroadcast: {
      type: Object
    },
    editSegment: {
      type: Object
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false,
    },
    noDefaultConditions: {
      type: Boolean,
      default: false,
    },
    selectedSocialPageId: null
  },
  computed: {
// connectedChannels provided by setup() via useSocialConnections composable
// socialPlatformConnectedArray provided by setup() via useSocialChannels
    authData() { return useAuthStore().authData; },
    tagOptions() {
      return this.tags.map(tag => ({
        title: tag,
        value: tag
      }));
    }
  },
  watch: {
    'conditionGroups': {
      deep: true,
      handler(newVal) {
        newVal.forEach(group => {
          group.forEach(condition => {
            if (condition.condition_type === CONDITION_TYPE.DLR_STATUS) {
              const currentValue = condition.value?.value?.args;
              const hasCurrentStructure = currentValue && 
                currentValue[0] === condition.broadcastId && 
                JSON.stringify(currentValue[1]) === JSON.stringify(condition.statuses);
              
              if (!hasCurrentStructure && condition.broadcastId && condition.statuses?.length) {
                this.$nextTick(() => {
                  this.updateDLRCondition(condition);
                });
              }
            }
            else if (condition.condition_type === CONDITION_TYPE.BROADCAST_INTERACTION_STATUS) {
              const currentValue = condition.value?.value?.args;
              const hasCurrentStructure = currentValue && 
                currentValue[0] === condition.broadcastId && 
                JSON.stringify(currentValue[1]) === JSON.stringify(condition.selectedButtons);
              
              if (!hasCurrentStructure && condition.broadcastId && condition.selectedButtons?.length) {
                this.$nextTick(() => {
                  this.updateBroadcastInteractionCondition(condition);
                });
              }
            }
            else if (condition.condition_type === CONDITION_TYPE.MARKETING_OPT_IN_STATE) {
              const currentValue = condition.value?.value;
              const hasCurrentStructure = currentValue && 
                JSON.stringify(currentValue) === JSON.stringify(condition.statuses);
              
              if (!hasCurrentStructure && condition.statuses?.length) {
                this.$nextTick(() => {
                  this.updateMarketingOptinStatusCondition(condition);
                });
              }
            }
          });
        });
      }
    }
  },
  async mounted() {
    this.mode = this.editBroadcast ? 'broadcast' : 'segment';
    await this.onComponentLoad();

    const editBroadcast = !!this.editBroadcast?.id; // EDIT BROADCAST CASE: preload values for selected broadcast
    const duplicateBroadcast = !!this.editBroadcast?.page_id?.trim(); // DUPLICATE BROADCAST CASE: preload values for selected broadcast
    const editSegment = !!this.editSegment?.id; // EDIT SEGMENT CASE: preload values for selected segment
    if (editBroadcast || editSegment || duplicateBroadcast) {
      if (this.mode == 'broadcast') {
        // Check if targeting_conditions exists and is not empty (handle both string and array cases)
        const hasTargetingConditions = this.editBroadcast?.targeting_conditions && 
          ((typeof this.editBroadcast.targeting_conditions === 'string' && this.editBroadcast.targeting_conditions.trim().length > 0) ||
           (Array.isArray(this.editBroadcast.targeting_conditions) && this.editBroadcast.targeting_conditions.length > 0));
        if (hasTargetingConditions) {
          this.oldVersionQueryHandler(this.editBroadcast.targeting_conditions);
        } else if (!this.noDefaultConditions) {
          this.setDefaultConditions();
        }
      }

      if (this.mode == 'segment') {
        this.oldVersionQueryHandler(this.editSegment.targeting_conditions);
      }
    } else if (!this.noDefaultConditions) {
      this.setDefaultConditions();
    }
    this.fetchCustomTags();

    this.$nextTick(() => {
      this.broadcastDropdownRef = this.$refs.broadcastDropdownRef;
    });
    document.addEventListener('click', this.handleClickOutsideBroadcastDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutsideBroadcastDropdown);
  },
  methods: {
    isConditionHiddenInUi(condition) {
      return condition?.condition_type == CONDITION_TYPE.INTERACTION_CHANNEL_PAGE_ID;
    },
    getVisibleConditionsCount(group) {
      if (!Array.isArray(group) || !group.length) {
        return 0;
      }
      return group.filter((condition) => !this.isConditionHiddenInUi(condition)).length;
    },
    shouldShowOrDivider(group, cIndex) {
      if (!Array.isArray(group) || !group.length) {
        return false;
      }
      const currentCondition = group[cIndex];
      if (this.isConditionHiddenInUi(currentCondition)) {
        return false;
      }

      for (let i = cIndex + 1; i < group.length; i++) {
        if (!this.isConditionHiddenInUi(group[i])) {
          return true;
        }
      }

      return false;
    },
    isHiddenConditionGroup(group) {
      return this.getVisibleConditionsCount(group) == 0;
    },
    shouldShowGroupDivider(gIndex) {
      const currentGroup = this.conditionGroups[gIndex];
      if (this.isHiddenConditionGroup(currentGroup)) {
        return false;
      }

      for (let i = gIndex + 1; i < this.conditionGroups.length; i++) {
        if (!this.isHiddenConditionGroup(this.conditionGroups[i])) {
          return true;
        }
      }

      return false;
    },
    onSelectCustomTag(thisCondition, data) {
      thisCondition.value = data.value;
    },
    isDefaultCondition(group, gIndex) {
      if (gIndex == 0) {
        if (group[0]?.q?.includes('platform=')) {
          return true;
        }
      }

      if (group[0]?.q?.includes('pageid=')) {
        return true;
      }

      if (group[0]?.q?.includes('marketing_opt_in_state')) {
        return true;
      }
      return false;
    },
    oldVersionQueryHandler(targeting_conditions) {
      // check if segment is old version. In old version raw_data was in targeting_conditions
      let isOldVersion = false;
      if (targeting_conditions?.includes("raw_data")) {
        isOldVersion = true;
        try {
          // backward compatibility
          const conditions = JSON.parse(targeting_conditions);
          const operator = conditions[0].operator == 'and' ? '&&' : '||';
          let queryString = '';
          conditions.forEach((condition) => {
            if (queryString != '') {
              queryString += ` ${operator} `;
            }
            queryString += decodeURIComponent(condition.query);
          });
          this.query = queryString;
        } catch (error) {
          console.error(error);
        }
      }

      if (!isOldVersion) {
        this.query = targeting_conditions;
      }
      this.generateConditionsFromQuery();
      this.updateSelectedBroadcastFromDLR();
    },
    async updateSelectedBroadcastFromDLR() {
      this.loadingBroadcastDetails = true;
      try {
      for (const group of this.conditionGroups) {
        for (const condition of group) {
          // Handle DLR Status
          if (condition.condition_type === this.CONDITION_TYPE.DLR_STATUS && condition.broadcastId) {
            try {
              const response = await apiInterceptor.get(environment("VUE_APP_API_URL") + `broadcasts/v1/broadcasts/${condition.broadcastId}`);
              if (response && response.name) {
                condition.broadcastSearchTerm = response.name;
                condition._lastSelectedName = response.name;
                this.selectedBroadcast = response.name;
              } else {
                condition.broadcastSearchTerm = '';
                this.selectedBroadcast = '';
              }
            } catch (e) {
              condition.broadcastSearchTerm = '';
              this.selectedBroadcast = '';
            }
          }
          
          // Handle Broadcast Interaction Status
          if (condition.condition_type === this.CONDITION_TYPE.BROADCAST_INTERACTION_STATUS && condition.broadcastId) {
            try {
              // Store the button IDs that were parsed from the SQL query before fetching
              const savedButtonIds = condition.selectedButtons ? [...condition.selectedButtons] : [];
              
              // Fetch broadcast name and populate the search field
              const response = await apiInterceptor.get(environment("VUE_APP_API_URL") + `broadcasts/v1/broadcasts/${condition.broadcastId}`);
              if (response && response.name) {
                condition.broadcastSearchTerm = response.name;
                condition._lastSelectedName = response.name;
                
                // Fetch broadcast data to get elements and buttons
                await this.fetchBroadcastDataForEdit(condition.broadcastId, condition, savedButtonIds);
              } else {
                // Broadcast not found or deleted
                condition.broadcastSearchTerm = '';
                condition.broadcastElements = [];
                condition.selectedElements = [];
                condition.availableButtons = [];
                condition.selectedButtons = [];
              }
            } catch (e) {
              console.error('Error fetching broadcast for Broadcast Interaction Status:', e);
              condition.broadcastSearchTerm = '';
              condition.broadcastElements = [];
              condition.selectedElements = [];
              condition.availableButtons = [];
              condition.selectedButtons = [];
            }
          }
        }
      }
      } finally {
        this.loadingBroadcastDetails = false;
      }
    },
    async fetchBroadcastDataForEdit(broadcastId, condition, savedButtonIds) {
      try {
        condition.broadcastDataLoading = true;
        
        const response = await apiInterceptor.get(environment("VUE_APP_API_URL") + `broadcasts/v1/broadcasts/${broadcastId}`);
        if (response) {
          const broadcastData = response;
          // Extract elements from answers
          const elements = [];
          const elementsContainingButtons = new Set();
          
          if (broadcastData.answers && Array.isArray(broadcastData.answers)) {
            broadcastData.answers.forEach(answer => {
              if (answer.template) {
                // Extract buttons from template elements (carousel/card/richcard)
                if (answer.template.elements && Array.isArray(answer.template.elements)) {
                  answer.template.elements.forEach(element => {
                    const elementData = {
                      id: element.id || `element_${elements.length}`,
                      title: element.title || element.subtitle || `Element ${element.id || elements.length}`,
                      type: element.type,
                      buttons: []
                    };
                    
                    // Extract buttons from element
                    if (element.buttons && Array.isArray(element.buttons)) {
                      element.buttons.forEach(button => {
                        const buttonId = button.id || button.value || `button_${elementData.buttons.length}`;
                        elementData.buttons.push({
                          id: buttonId,
                          title: button.title || button.text,
                          description: button.description,
                          type: button.type
                        });
                        
                        // Check if this element contains any of the saved button IDs
                        if (savedButtonIds.some(savedId => savedId == buttonId || Number(savedId) == Number(buttonId))) {
                          elementsContainingButtons.add(elementData.id);
                        }
                      });
                    }
                    
                    elements.push(elementData);
                  });
                }
                
                // Extract buttons from template level (quickreply and other template types)
                if (answer.template.buttons && Array.isArray(answer.template.buttons)) {
                  const templateButtons = {
                    id: `template_buttons_${elements.length}`,
                    title: answer.template_type ? `${answer.template_type} buttons` : 'Quick Reply Buttons',
                    type: answer.template_type || 'quickreply',
                    buttons: []
                  };
                  
                  answer.template.buttons.forEach(button => {
                    const buttonId = button.id || button.value || `button_${templateButtons.buttons.length}`;
                    templateButtons.buttons.push({
                      id: buttonId,
                      title: button.title || button.text,
                      description: button.description,
                      type: button.type
                    });
                    
                    // Check if this template contains any of the saved button IDs
                    if (savedButtonIds.some(savedId => savedId == buttonId || Number(savedId) == Number(buttonId))) {
                      elementsContainingButtons.add(templateButtons.id);
                    }
                  });
                  
                  if (templateButtons.buttons.length > 0) {
                    elements.push(templateButtons);
                  }
                }
              }
            });
          }
          
          // Store elements in condition
          condition.broadcastElements = elements;
          
          // Auto-select elements that contain the saved button IDs
          condition.selectedElements = Array.from(elementsContainingButtons);
          
          // Update available buttons based on selected elements
          this.updateAvailableButtons(condition);
          
          // Re-select the saved button IDs (only those that still exist)
          const availableButtonIds = condition.availableButtons.map(b => b.id);
          condition.selectedButtons = savedButtonIds.filter(savedId => 
            availableButtonIds.some(availId => availId == savedId || Number(availId) == Number(savedId))
          );
          
          // Update the condition value to reflect the current state
          if (condition.selectedButtons.length > 0) {
            this.updateBroadcastInteractionCondition(condition);
          }
        }
      } catch (error) {
        console.error('Error fetching broadcast data for edit:', error);
        condition.broadcastElements = [];
        condition.selectedElements = [];
        condition.availableButtons = [];
        condition.selectedButtons = [];
      } finally {
        condition.broadcastDataLoading = false;
      }
    },
    onDragEnterGroup(evt) {
      console.info('drag enter group');
      this.droppingInLastGroup = true;
      evt.preventDefault();
    },
    onDragLeaveGroup(evt) {
      console.info('drag leave group');
      this.droppingInLastGroup = false;
    },
    getQueryDetails(query) {
      let tempQuery = query.replaceAll('“', '"').replaceAll('”', '"');
      let splitBy = "", valueDisplay, q = query;
      
      // Handle marketing opt-in state JSON condition first
      if (query.startsWith('{"key":"marketing_opt_in_state"') || query.includes('"key":"marketing_opt_in_state"')) {
        try {
          const jsonValue = JSON.parse(query);
          if (jsonValue.key === 'marketing_opt_in_state') {
            return {
              q: query,
              key: 'marketing_opt_in_state',
              value: jsonValue,
              valueDisplay: jsonValue.value,
              operator: jsonValue.operand,
              condition_type: KEY_CONDITION_TYPE_MAPPING['marketing_opt_in_state'],
              displayOperatorText: jsonValue.operand,
              staticOperator: 'is'
            };
          }
        } catch (error) {
          console.error('Error parsing marketing opt-in state condition in getQueryDetails:', error);
        }
      }

      // Handle marketing_opt_in_state IN (1, 0) format
      const marketingOptinInRegex = /marketing_opt_in_state\s+IN\s*\(([^)]+)\)/i;
      if (marketingOptinInRegex.test(query)) {
        const match = query.match(marketingOptinInRegex);
        if (match) {
          const valuesStr = match[1];
          // Extract values from the parentheses, handling both numbers and strings
          const values = valuesStr.split(',').map(val => {
            const trimmed = val.trim();
            // Remove quotes if present and convert to number
            const cleaned = trimmed.replace(/^['"]|['"]$/g, '');
            return isNaN(cleaned) ? cleaned : parseInt(cleaned, 10);
          });
          
          return {
            q: query,
            key: 'marketing_opt_in_state',
            value: { key: "marketing_opt_in_state", operand: "in", value: values },
            valueDisplay: values,
            operator: 'in',
            condition_type: KEY_CONDITION_TYPE_MAPPING['marketing_opt_in_state'],
            displayOperatorText: 'in',
            staticOperator: 'is',
            statuses: values
          };
        }
      }
      
      if (query.includes('unnest')) {
        splitBy = 'unnest';
      } else if (query.includes(" IN ")) {
        splitBy = " IN ";
      } else if (query.includes("!=")) {
        splitBy = "!=";
      } else if (query.includes("=")) {
        splitBy = "=";
      } else if (query.includes(">=")) {
        splitBy = ">=";
      } else if (query.includes(">=")) {
        splitBy = ">=";
      } else if (query.includes("<")) {
        splitBy = "<";
      } else if (query.includes(">")) {
        splitBy = ">";
      } else if (query.includes("is null")) {
        splitBy = "is null";
      }

      let key, value, operator, staticOperator = "";
      if (splitBy == "unnest") {
        // get key encapsulated in round brackets
        key = tempQuery.match(/\((.*)\)/)?.pop()?.trim() || null;


        if (tempQuery.includes('"')) {
          // get value encapsulated in double quotes
          value = tempQuery.match('"(.*)"')?.pop()?.trim() || null;

          // get operator in between double quote and unnest word
          let tempQ = tempQuery.split('"')?.pop();
          operator = tempQ.match('(.*)unnest')?.pop().trim() + ' unnest' || null;
        } else {
          value = tempQuery.split(' ')?.shift();

          // get operator in between value and unnest word
          let tempQ = tempQuery.replace(value, "");
          operator = tempQ.match('(.*)unnest')?.pop().trim() + ' unnest' || null;
        }

        // set static operator for display
        if (tempQuery.includes("(bots)")) {
          staticOperator = "for";
          key = "bots";
          q = tempQuery.replace("(Products)", "(bots)")
        }

        // while adding new condition added null as in blank value
        if (key == "custom_fields" && value == "null") {
          value = ":";
        }

      } else if (splitBy == " IN ") {
        // Handle IN operator specifically (like "marketing_opt_in_state IN (1, 0)")
        let arr = tempQuery.split(splitBy);
        key = arr[0]?.trim();
        let valuesStr = arr[1]?.trim();
        
        // Extract values from parentheses
        if (valuesStr.startsWith('(') && valuesStr.endsWith(')')) {
          valuesStr = valuesStr.slice(1, -1); // Remove parentheses
          const values = valuesStr.split(',').map(val => {
            const trimmed = val.trim();
            const cleaned = trimmed.replace(/^['"]|['"]$/g, '');
            return isNaN(cleaned) ? cleaned : parseInt(cleaned, 10);
          });
          value = values;
          valueDisplay = values;
        } else {
          value = valuesStr;
          valueDisplay = valuesStr;
        }

        operator = "in";
        staticOperator = "is";
      } else {
        let sanitizedQuery = tempQuery.replaceAll('"', "").replaceAll(" ", "");
        let arr = tempQuery.replaceAll('"', "").split(splitBy);
        key = arr[0]?.trim();
        value = arr[1]?.trim();

        // set static operator for display
        if (sanitizedQuery.includes("platform=")) {
          staticOperator = "was";
        } else if (sanitizedQuery.includes("user_gender=")) {
          staticOperator = "is";
        } else if (sanitizedQuery.includes("pageid=")) {
          staticOperator = "is";
        } else if (sanitizedQuery.includes("conversation_id=")) {
          staticOperator = "is";
        } else if (sanitizedQuery.includes("broadcast_interaction_status=")) {
          staticOperator = "is";
        } else if (sanitizedQuery.includes("marketing_opt_in_state=")) {
          staticOperator = "is";
        } else if (sanitizedQuery.includes("userReplyDate=")) {
          staticOperator = "is";
        }

        operator = splitBy;
      }

      let condition_type = KEY_CONDITION_TYPE_MAPPING[key];;
      let displayOperatorText = filterOperatorsMappingReverse[operator];
      
      // Add statuses field for IN operator (especially for marketing_opt_in_state)
      let result = { q, key, value, valueDisplay, operator, condition_type, displayOperatorText, staticOperator };
      if (operator === 'in' && Array.isArray(value)) {
        result.statuses = value;
      }
      
      return result;
    },
    getQueryWithUpdatedValue(objCondition) {
      let tempQuery = objCondition.q.replaceAll('“', '"').replaceAll('”', '"');
      const { operator, value, key, condition_type } = objCondition;
      if (tempQuery.includes("(tags)")) {
        tempQuery = `"${value}" ${operator} (tags)`;
      } else if (tempQuery.includes("LastActive")) {
        tempQuery = `${key}${operator}"${value}"`;
      } else if (tempQuery.includes("user_lastreply_time")) {
        tempQuery = `${key}${operator}"${value}"`;
      } else if (tempQuery.includes("userReplyDate")) {
        tempQuery = `${key}${operator}"${value}"`;
      } else if (tempQuery.includes("unnest")) {
        if (tempQuery.includes('"')) {
          const regex = /"(.*)"/;
          tempQuery = tempQuery.replace(regex, `"${value}"`);
        } else {
          const regex = /([^\s]+)/;
          tempQuery = tempQuery.replace(regex, value);
        }
        tempQuery = tempQuery.replace('(bots)', '(Products)');
      } else if (condition_type === CONDITION_TYPE.DLR_STATUS && objCondition.broadcastId && objCondition.statuses?.length) {
        const userId = this.authData?.userId;
        const broadcastId = objCondition.broadcastId;
        const statuses = JSON.stringify(objCondition.statuses);
        tempQuery = `conversation_id in (select * from analytics.tf_Conversation_Broadcast_DLR(${userId},${broadcastId},${statuses}))`;
      } else if (condition_type === CONDITION_TYPE.BROADCAST_INTERACTION_STATUS && objCondition.broadcastId && objCondition.selectedButtons?.length) {
        const userId = this.authData?.userId;
        const broadcastId = objCondition.broadcastId;
        // Format button IDs as array notation [id1, id2, ...]
        const buttonIdsArray = objCondition.selectedButtons.map(id => typeof id === 'number' ? id : Number(id));
        const buttonIds = `[${buttonIdsArray.join(', ')}]`;
        tempQuery = `conversation_id IN (SELECT * FROM analytics.tf_Conversation_JumperEvent_Template( ${userId}, ${broadcastId}, ${buttonIds}))`;
      } else if (condition_type === CONDITION_TYPE.MARKETING_OPT_IN_STATE && objCondition.statuses?.length) {
        // Check if original query was in SQL format, preserve that format
        if (objCondition.q && /marketing_opt_in_state\s+IN\s*\(/i.test(objCondition.q)) {
          // Generate SQL format
          const statusValues = objCondition.statuses.map(status => 
            typeof status === 'string' && isNaN(status) ? `"${status}"` : status
          ).join(', ');
          tempQuery = `marketing_opt_in_state IN (${statusValues})`;
        } else {
          // Generate JSON format (default)
          const marketingOptinValue = {
            key: "marketing_opt_in_state",
            operand: "in",
            value: objCondition.statuses
          };
          tempQuery = JSON.stringify(marketingOptinValue);
        }
      } else {
        if (operator == 'is null') {
          tempQuery = `${key} ${operator}`;
        } else if (tempQuery.includes('"')) {
          tempQuery = `${key}${operator}"${value}"`;
        } else {
          if (["user_name", "user_email", "user_mobilenumber", "user_gender", "user_lastreply_time", "userReplyDate"].includes(key)) {
            tempQuery = `${key}${operator}"${value}"`;
          } else {
            tempQuery = `${key}${operator}${value}`;
          }
        }
      }
      return tempQuery;
    },
    getQueryStringFromConditionArray() {
      let strQueryString = '';
      this.conditionGroups.forEach((group) => {

        if (strQueryString != '' && group.length) {
          strQueryString += '&&';
        }

        if (group.length > 1) {
          const strGroupQuery = group.map((objCondition) => {
            return this.getQueryWithUpdatedValue(objCondition);
          }).join('||');
          strQueryString += `(${strGroupQuery})`;
        } else if (group[0]?.q) {
          strQueryString += this.getQueryWithUpdatedValue(group[0]);
        }

      });
      return strQueryString;
    },
    generateConditionsFromQuery() {
      // return in case of blank query string
      if (!this.query?.trim()) {
        return;
      }

      let strMainQuery = decodeURIComponent(this.query).replaceAll('“', '"');
      const arrQueries = strMainQuery.split("&&");

      // iterate through each word of query
      arrQueries.forEach((query) => {
        query = query.trim();
        let groupItems = [];

        // if group of conditions wrapped inside brackets
        if (query[0] == '(') {
          query = query.slice(1, -1); // remove round brackets from query
          const arrGroupQueries = query.split("||");
          arrGroupQueries.forEach((groupQuery) => {
            groupQuery = groupQuery.trim();
            // Marketing opt-in state JSON pattern
            if (groupQuery.startsWith('{"key":"marketing_opt_in_state"') || groupQuery.includes('"key":"marketing_opt_in_state"')) {
              try {
                const jsonValue = JSON.parse(groupQuery);
                if (jsonValue.key === 'marketing_opt_in_state') {
                  let grpItem = {
                    q: groupQuery,
                    key: 'marketing_opt_in_state',
                    value: jsonValue,
                    operator: jsonValue.operand,
                    condition_type: CONDITION_TYPE.MARKETING_OPT_IN_STATE,
                    statuses: Array.isArray(jsonValue.value) ? jsonValue.value.map(val => typeof val === 'number' ? val : parseInt(val, 10)) : [typeof jsonValue.value === 'number' ? jsonValue.value : parseInt(jsonValue.value, 10)],
                    staticOperator: 'is',
                    displayOperatorText: jsonValue.operand
                  };
                  groupItems.push(grpItem);
                  return;
                }
              } catch (error) {
                console.error('Error parsing marketing opt-in state condition:', error);
              }
            }

            // Marketing opt-in state SQL IN pattern
            const marketingOptinInRegex = /marketing_opt_in_state\s+IN\s*\(([^)]+)\)/i;
            if (marketingOptinInRegex.test(groupQuery)) {
              const match = groupQuery.match(marketingOptinInRegex);
              if (match) {
                const valuesStr = match[1];
                const values = valuesStr.split(',').map(val => {
                  const trimmed = val.trim();
                  const cleaned = trimmed.replace(/^['"]|['"]$/g, '');
                  return isNaN(cleaned) ? cleaned : parseInt(cleaned, 10);
                });
                
                let grpItem = {
                  q: groupQuery,
                  key: 'marketing_opt_in_state',
                  value: { key: "marketing_opt_in_state", operand: "in", value: values },
                  operator: 'in',
                  condition_type: CONDITION_TYPE.MARKETING_OPT_IN_STATE,
                  statuses: values,
                  staticOperator: 'is',
                  displayOperatorText: 'in'
                };
                groupItems.push(grpItem);
                return;
              }
            }

            // DLR status SQL pattern
            const dlrRegex = /conversation_id in\s*\(\s*select\s*\*\s*from\w*\s+analytics\.tf_Conversation_Broadcast_DLR\((\d+),(\d+),(.+)\)\s*\)/i;
            if (dlrRegex.test(groupQuery)) {
              const match = groupQuery.match(dlrRegex);
              if (match) {
                const broadcastId = match[2];
                let statuses = [];
                const statusesRaw = match[3];
                const statusMatches = statusesRaw.match(/['\"](.*?)['\"]/g);
                statuses = statusMatches ? statusMatches.map(s => s.replace(/^['\"]|['\"]$/g, '').trim()) : [];
                let grpItem = {
                  q: groupQuery,
                  key: 'conversation_id',
                  value: null,
                  operator: 'in',
                  condition_type: CONDITION_TYPE.DLR_STATUS,
                  broadcastId: Number(broadcastId),
                  statuses,
                  staticOperator: 'is',
                  displayOperatorText: 'in',
                  broadcastSearchTerm: '',
                  broadcastSearchResults: [],
                  showBroadcastDropdown: false,
                  broadcastSearchLoading: false
                };
                groupItems.push(grpItem);
                return;
              }
            }

            // Broadcast interaction status SQL pattern
            // conversation_id IN (SELECT * FROM analytics.tf_Conversation_JumperEvent_Template( userId, broadcastId, [buttonIds]))
            const broadcastInteractionRegex = /conversation_id\s+IN\s*\(\s*SELECT\s*\*\s*FROM\s+analytics\.tf_Conversation_JumperEvent_Template\s*\(\s*([\d,\s]+),\s*\[([^\]]+)\]\s*\)\s*\)/i;
            
            let broadcastInteractionMatch = null;
            let broadcastId = null;
            let buttonIds = [];
            
            if (broadcastInteractionRegex.test(groupQuery)) {
              broadcastInteractionMatch = groupQuery.match(broadcastInteractionRegex);
              if (broadcastInteractionMatch) {
                // Parse the args before the array: could be "userId, broadcastId" or just "broadcastId"
                const argsBeforeArray = broadcastInteractionMatch[1].split(',').map(s => s.trim()).filter(s => s);
                // Last arg before array is the broadcastId
                broadcastId = argsBeforeArray[argsBeforeArray.length - 1];
                
                // Parse button IDs from array notation [id1, id2, ...]
                const buttonIdsRaw = broadcastInteractionMatch[2];
                buttonIds = buttonIdsRaw.split(',').map(s => {
                  const trimmed = s.trim();
                  // Handle both numeric and string IDs
                  return Number.isNaN(trimmed) ? trimmed.replace(/^['"]|['"]$/g, '') : Number(trimmed);
                }).filter(id => id !== '' && id !== null && id !== undefined);
              }
            }
            
            if (broadcastInteractionMatch && broadcastId) {
              let grpItem = {
                q: groupQuery,
                key: 'conversation_id',
                value: null,
                operator: 'in',
                condition_type: CONDITION_TYPE.BROADCAST_INTERACTION_STATUS,
                broadcastId: Number(broadcastId),
                broadcastElements: [],
                selectedElement: null,
                selectedElements: [],
                selectedButtons: buttonIds,
                availableButtons: [],
                templateIds: buttonIds, // Keep for backwards compatibility
                staticOperator: 'is',
                displayOperatorText: 'in',
                broadcastSearchTerm: '',
                broadcastSearchResults: [],
                showBroadcastDropdown: false,
                broadcastSearchLoading: false,
                broadcastDataLoading: false
              };
              groupItems.push(grpItem);
              return;
            }
            let qPrams = this.getQueryDetails(groupQuery) || {};
            const q = decodeURIComponent(groupQuery);
            let grpItem = { q, ...qPrams };
            groupItems.push(grpItem);
          })
        } else {
          // else if single condition separated by &&
          // Marketing opt-in state JSON pattern
          if (query.startsWith('{"key":"marketing_opt_in_state"') || query.includes('"key":"marketing_opt_in_state"')) {
            try {
              const jsonValue = JSON.parse(query);
              if (jsonValue.key === 'marketing_opt_in_state') {
                let grpItem = {
                  q: query,
                  key: 'marketing_opt_in_state',
                  value: jsonValue,
                  operator: jsonValue.operand,
                  condition_type: CONDITION_TYPE.MARKETING_OPT_IN_STATE,
                  statuses: Array.isArray(jsonValue.value) ? jsonValue.value.map(val => typeof val === 'number' ? val : parseInt(val, 10)) : [typeof jsonValue.value === 'number' ? jsonValue.value : parseInt(jsonValue.value, 10)],
                  staticOperator: 'is',
                  displayOperatorText: jsonValue.operand
                };
                groupItems.push(grpItem);
                this.conditionGroups.push(groupItems);
                return;
              }
            } catch (error) {
              console.error('Error parsing marketing opt-in state condition:', error);
            }
          }

          // Marketing opt-in state SQL IN pattern
          const marketingOptinInRegex = /marketing_opt_in_state\s+IN\s*\(([^)]+)\)/i;
          if (marketingOptinInRegex.test(query)) {
            const match = query.match(marketingOptinInRegex);
            if (match) {
              const valuesStr = match[1];
              const values = valuesStr.split(',').map(val => {
                const trimmed = val.trim();
                const cleaned = trimmed.replace(/^['"]|['"]$/g, '');
                return isNaN(cleaned) ? cleaned : parseInt(cleaned, 10);
              });
              
              let grpItem = {
                q: query,
                key: 'marketing_opt_in_state',
                value: { key: "marketing_opt_in_state", operand: "in", value: values },
                operator: 'in',
                condition_type: CONDITION_TYPE.MARKETING_OPT_IN_STATE,
                statuses: values,
                staticOperator: 'is',
                displayOperatorText: 'in'
              };
              groupItems.push(grpItem);
              this.conditionGroups.push(groupItems);
              return;
            }
          }

          // DLR status SQL pattern
          const dlrRegex = /conversation_id in\s*\(\s*select\s*\*\s*from\w*\s+analytics\.tf_Conversation_Broadcast_DLR\((\d+),(\d+),(.+)\)\s*\)/i;
          if (dlrRegex.test(query)) {
            const match = query.match(dlrRegex);
            if (match) {
              const broadcastId = match[2];
              let statuses = [];
              const statusesRaw = match[3];
              const statusMatches = statusesRaw.match(/['\"](.*?)['\"]/g);
              statuses = statusMatches ? statusMatches.map(s => s.replace(/^['\"]|['\"]$/g, '').trim()) : [];
              let grpItem = {
                q: query,
                key: 'conversation_id',
                value: null,
                operator: 'in',
                condition_type: CONDITION_TYPE.DLR_STATUS,
                broadcastId: Number(broadcastId),
                statuses,
                staticOperator: 'is',
                displayOperatorText: 'in',
                broadcastSearchTerm: '',
                broadcastSearchResults: [],
                showBroadcastDropdown: false,
                broadcastSearchLoading: false
              };
              groupItems.push(grpItem);
              this.conditionGroups.push(groupItems);
              return;
            }
          }

          // Broadcast interaction status SQL pattern
          // conversation_id IN (SELECT * FROM analytics.tf_Conversation_JumperEvent_Template( userId, broadcastId, [buttonIds]))
          const broadcastInteractionRegexSingle = /conversation_id\s+IN\s*\(\s*SELECT\s*\*\s*FROM\s+analytics\.tf_Conversation_JumperEvent_Template\s*\(\s*([\d,\s]+),\s*\[([^\]]+)\]\s*\)\s*\)/i;
          
          let broadcastInteractionMatchSingle = null;
          let broadcastIdSingle = null;
          let buttonIdsSingle = [];
          
          if (broadcastInteractionRegexSingle.test(query)) {
            broadcastInteractionMatchSingle = query.match(broadcastInteractionRegexSingle);
            if (broadcastInteractionMatchSingle) {
              // Parse the args before the array: could be "userId, broadcastId" or just "broadcastId"
              const argsBeforeArray = broadcastInteractionMatchSingle[1].split(',').map(s => s.trim()).filter(s => s);
              // Last arg before array is the broadcastId
              broadcastIdSingle = argsBeforeArray[argsBeforeArray.length - 1];
              
              // Parse button IDs from array notation [id1, id2, ...]
              const buttonIdsRaw = broadcastInteractionMatchSingle[2];
              buttonIdsSingle = buttonIdsRaw.split(',').map(s => {
                const trimmed = s.trim();
                // Handle both numeric and string IDs
                return Number.isNaN(trimmed) ? trimmed.replace(/^['"]|['"]$/g, '') : Number(trimmed);
              }).filter(id => id !== '' && id !== null && id !== undefined);
            }
          }
          
          if (broadcastInteractionMatchSingle && broadcastIdSingle) {
            let grpItem = {
              q: query,
              key: 'conversation_id',
              value: null,
              operator: 'in',
              condition_type: CONDITION_TYPE.BROADCAST_INTERACTION_STATUS,
              broadcastId: Number(broadcastIdSingle),
              broadcastElements: [],
              selectedElement: null, // Keep for backwards compatibility
              selectedElements: [], // New multi-select property
              selectedButtons: buttonIdsSingle,
              availableButtons: [],
              templateIds: buttonIdsSingle, // Keep for backwards compatibility
              staticOperator: 'is',
              displayOperatorText: 'in',
              broadcastSearchTerm: '',
              broadcastSearchResults: [],
              showBroadcastDropdown: false,
              broadcastSearchLoading: false,
              broadcastDataLoading: false
            };
            groupItems.push(grpItem);
            this.conditionGroups.push(groupItems);
            return;
          }
          let qPrams = this.getQueryDetails(query) || {};
          const q = decodeURIComponent(query);
          let grpItem = { q, ...qPrams };
          groupItems.push(grpItem);
        }

        this.conditionGroups.push(groupItems);
      });
      this.updateSelectedBroadcastFromDLR();
    },
    resetDragParams() {
      this.dragIndex = null;
      this.dropIndex = null;
      this.prevDropIndex = null;
      this.conditionsBeforeDragDrop = null;
    },
    startDrag(e, gIndex, cIndex) {
      this.resetDragParams();
      this.conditionsBeforeDragDrop = [...this.conditions];
      this.conditionToDrop = this.conditions[cIndex];
      this.dragIndex = cIndex;
      this.dragFromGroupIndex = gIndex;
      e.dataTransfer.effectAllowed = "copyMove";
      e.dataTransfer.dropEffect = "copy";
    },
    startDragItem(e, gIndex, cIndex) {
      e.stopImmediatePropagation();
      this.resetDragParams();
      this.conditionsBeforeDragDrop = [...this.conditionGroups];
      this.conditionToDrop = this.conditionGroups[gIndex][cIndex];
      this.dragIndex = cIndex;
      this.dragFromGroupIndex = gIndex;
      e.dataTransfer.effectAllowed = "copyMove";
      e.dataTransfer.dropEffect = "copy";
    },
    startDragGroup(e, gIndex, cIndex) {
      this.resetDragParams();
      // e.stopImmediatePropagation();
      this.dragGroupIndex = gIndex;
      e.dataTransfer.effectAllowed = "copyMove";
      e.dataTransfer.dropEffect = "copy";
      e.currentTarget.classList.add("dragging");
    },
    dragDropElementSwitchHandler(evt) {
      if (this.conditionsBeforeDragDrop && (this.prevDropIndex == null || this.prevDropIndex != this.dropIndex)) {
        this.conditions = [...this.conditionsBeforeDragDrop];
        this.conditions.splice(this.dragIndex, 1);
        this.conditions.splice(this.dropIndex, 0, this.conditionToDrop);
        this.prevDropIndex = this.dropIndex;
      }
    },
    clearEmptyGroups() {
      this.conditionGroups = this.conditionGroups.filter((elm) => elm.length);
    },
    onDropItem(evt, gIndex, cIndex) {
      evt.stopImmediatePropagation();
      if (this.isDefaultCondition(this.conditionGroups[gIndex], gIndex)) {
        return;
      }

      if (this.conditionToDrop) {
        this.$nextTick(() => {
          let objConditionToDrop = { ...this.conditionToDrop };
          this.conditionGroups[gIndex].splice(cIndex + 1, 0, objConditionToDrop);
          this.conditionGroups[this.dragFromGroupIndex].splice(this.dragIndex, 1);
          this.dragIndex = null;
          this.clearEmptyGroups();
        });
      }
    },
    onDropGroup(evt, group, gIndex) {
      evt.stopImmediatePropagation();
      if (this.dragIndex != null) {
        evt.preventDefault();
        return false;
      }

      if (this.isDefaultCondition(this.conditionGroups[gIndex], gIndex)) {
        return;
      }

      this.$nextTick(() => {
        const groupToDrop = this.conditionGroups[this.dragGroupIndex].map((elm) => { return {...elm}});
        this.conditionGroups.splice(this.dragGroupIndex, 1);
        this.conditionGroups.splice(gIndex, 0, groupToDrop);
        this.dragGroupIndex = null;
        this.clearEmptyGroups();
      });
    },
    onDropInLastGroup(evt) {
      evt.stopImmediatePropagation();
      this.$nextTick(() => {
        this.conditionGroups.push([this.conditionToDrop]);
        this.conditionGroups[this.dragFromGroupIndex].splice(this.dragIndex, 1);
        this.droppingInLastGroup = false;
        this.clearEmptyGroups();
      });
    },
    onDragEnter(evt, cIndex) {
      evt.stopImmediatePropagation();
      this.dropIndex = cIndex;
      setTimeout(() => {
        this.dragDropElementSwitchHandler(evt);
        evt.preventDefault();
      }, 100);
    },
    updateBroadcastSelection(selectedItem, condition) {
      condition.broadcastId = selectedItem.selectedValue;
      this.updateDLRCondition(condition);
      this.updateBroadcastInteractionCondition(condition);
      this.updateMarketingOptinStatusCondition(condition);
    },
    updateMarketingOptinStatusSelection(event, condition) {
      if (!event?.detail?.value) return;
      
      // Ensure values are integers (HTML form elements may return strings)
      const newStatuses = [...event.detail.value].map(val => typeof val === 'number' ? val : parseInt(val, 10));
      const currentStatuses = condition.statuses || [];
      
      if (JSON.stringify(newStatuses) !== JSON.stringify(currentStatuses)) {
        const updatedCondition = {
          ...condition,
          statuses: newStatuses
        };        
        this.$nextTick(() => {
          condition.statuses = newStatuses;
          this.updateMarketingOptinStatusCondition(updatedCondition);
        });
      }
    },
    updateStatusSelection(event, condition) {
      if (!event?.detail?.value) return;
      
      const newStatuses = [...event.detail.value];
      const currentStatuses = condition.statuses || [];
      
      if (JSON.stringify(newStatuses) !== JSON.stringify(currentStatuses)) {
        const updatedCondition = {
          ...condition,
          statuses: newStatuses
        };        
        this.$nextTick(() => {
          condition.statuses = newStatuses;
          this.updateDLRCondition(updatedCondition);
        });
      }
    },
    updateTemplateSelection(event, condition) {
      if (!event?.detail?.value) return;
      
      const newTemplateIds = [...event.detail.value];
      const currentTemplateIds = condition.templateIds || [];
      
      if (JSON.stringify(newTemplateIds) !== JSON.stringify(currentTemplateIds)) {
        const updatedCondition = {
          ...condition,
          templateIds: newTemplateIds
        };        
        this.$nextTick(() => {
          condition.templateIds = newTemplateIds;
          this.updateBroadcastInteractionCondition(updatedCondition);
        });
      }
    },
    updateElementSelection(event, condition) {
      if (!event?.detail?.value) return;
      
      const newSelectedElements = [...event.detail.value];
      condition.selectedElements = newSelectedElements;
      
      // Clear selected buttons when elements change
      condition.selectedButtons = [];
      
      // Update available buttons based on selected elements (combine buttons from all selected elements)
      this.updateAvailableButtons(condition);
    },
    updateButtonSelection(event, condition) {
      if (!event?.detail?.value) return;
      
      const newButtonIds = [...event.detail.value];
      condition.selectedButtons = newButtonIds;
      
      // Update the condition with new button IDs
      const updatedCondition = {
        ...condition,
        templateIds: newButtonIds // Keep this as templateIds for backwards compatibility
      };
      
      this.$nextTick(() => {
        this.updateBroadcastInteractionCondition(updatedCondition);
      });
    },
    updateAvailableButtons(condition) {
      if (!condition.selectedElements?.length || !condition.broadcastElements) {
        condition.availableButtons = [];
        return;
      }
      
      // Combine buttons from all selected elements
      const allButtons = [];
      const buttonMap = new Map(); // Use Map to avoid duplicate buttons
      
      condition.selectedElements.forEach(elementId => {
        const selectedElement = condition.broadcastElements.find(el => el.id === elementId);
        
        if (selectedElement && selectedElement.buttons) {
          selectedElement.buttons.forEach(button => {
            // Use button ID as key to avoid duplicates
            if (!buttonMap.has(button.id)) {
              buttonMap.set(button.id, button);
              allButtons.push(button);
            }
          });
        }
      });
      
      condition.availableButtons = allButtons;
    },
    async fetchBroadcastData(broadcastId, condition) {
      try {
        condition.broadcastDataLoading = true;
        
        const response = await apiInterceptor.get(environment("VUE_APP_API_URL") + `broadcasts/v1/broadcasts/${broadcastId}`);
        if (response) {
          const broadcastData = response;
          // Extract elements from answers
          const elements = [];
          if (broadcastData.answers && Array.isArray(broadcastData.answers)) {
            broadcastData.answers.forEach(answer => {
              if (answer.template) {
                // Extract buttons from template elements (carousel/card/richcard)
                if (answer.template.elements && Array.isArray(answer.template.elements)) {
                  answer.template.elements.forEach(element => {
                    const elementData = {
                      id: element.id || `element_${elements.length}`,
                      title: element.title || element.subtitle || `Element ${element.id || elements.length}`,
                      type: element.type,
                      buttons: []
                    };
                    
                    // Extract buttons from element
                    if (element.buttons && Array.isArray(element.buttons)) {
                      element.buttons.forEach(button => {
                        elementData.buttons.push({
                          id: button.id || button.value || `button_${elementData.buttons.length}`,
                          title: button.title || button.text,
                          description: button.description,
                          type: button.type
                        });
                      });
                    }
                    
                    elements.push(elementData);
                  });
                }
                
                // Extract buttons from template level (quickreply and other template types)
                if (answer.template.buttons && Array.isArray(answer.template.buttons)) {
                  const templateButtons = {
                    id: `template_buttons_${elements.length}`,
                    title: answer.template_type ? `${answer.template_type} buttons` : 'Quick Reply Buttons',
                    type: answer.template_type || 'quickreply',
                    buttons: []
                  };
                  
                  answer.template.buttons.forEach(button => {
                    templateButtons.buttons.push({
                      id: button.id || button.value || `button_${templateButtons.buttons.length}`,
                      title: button.title || button.text,
                      description: button.description,
                      type: button.type
                    });
                  });
                  
                  if (templateButtons.buttons.length > 0) {
                    elements.push(templateButtons);
                  }
                }
              }
            });
          }
          
          // Store elements in condition
          condition.broadcastElements = elements;
          condition.availableButtons = [];
          condition.selectedElement = null;
          condition.selectedButtons = [];
          
        }
      } catch (error) {
        console.error('Error fetching broadcast data:', error);
        condition.broadcastElements = [];
        condition.availableButtons = [];
      } finally {
        condition.broadcastDataLoading = false;
      }
    },
    updateDLRCondition(condition) {
      if (!condition) return;
      
      const hasValidBroadcast = Boolean(condition.broadcastId);
      const hasValidStatuses = Array.isArray(condition.statuses) && condition.statuses.length > 0;
      
      if (hasValidBroadcast && hasValidStatuses) {
        // Create the new value object with authdata.user_id included before broadcast ID
        const updatedValue = {
          operand: "in",
          value: {
            table: "broadcast_dlr",
            args: [this.authData?.userId, condition.broadcastId, [...condition.statuses]]
          }
        };
        
        // Only update if the value has actually changed
        const currentValueStr = JSON.stringify(condition.value || {});
        const newValueStr = JSON.stringify(updatedValue);
        
        if (currentValueStr !== newValueStr) {
          this.$nextTick(() => {
            condition.value = updatedValue;
            condition.q = `conversation_id = ${JSON.stringify(updatedValue)}`;
          });
        }
      }
    },
    updateBroadcastInteractionCondition(condition) {
      if (!condition) return;
      
      const hasValidBroadcast = Boolean(condition.broadcastId);
      const hasValidButtonIds = Array.isArray(condition.selectedButtons) && condition.selectedButtons.length > 0;
      
      if (hasValidBroadcast && hasValidButtonIds) {
        // Create the new value object with authdata.user_id included before broadcast ID
        const updatedValue = {
          operand: "in",
          value: {
            table: "jumper_event_template",
            args: [this.authData?.userId, condition.broadcastId, [...condition.selectedButtons]]
          }
        };
        
        // Only update if the value has actually changed
        const currentValueStr = JSON.stringify(condition.value || {});
        const newValueStr = JSON.stringify(updatedValue);
        
        if (currentValueStr !== newValueStr) {
          this.$nextTick(() => {
            condition.value = updatedValue;
            condition.q = `broadcast_interaction_status = ${JSON.stringify(updatedValue)}`;
          });
        }
      }
    },
    updateMarketingOptinStatusCondition(condition) {
      if (!condition) return;
      
      const hasValidStatuses = Array.isArray(condition.statuses) && condition.statuses.length > 0;
      
      if (hasValidStatuses) {
        // Create the new value object in the required format
        const updatedValue = {
          key: "marketing_opt_in_state",
          operand: "in",
          value: [...condition.statuses]
        };
        
        // Only update if the value has actually changed
        const currentValueStr = JSON.stringify(condition.value || {});
        const newValueStr = JSON.stringify(updatedValue);
        
        if (currentValueStr !== newValueStr) {
          this.$nextTick(() => {
            condition.value = updatedValue;
            condition.q = JSON.stringify(updatedValue);
          });
        }
      }
    },
    addCondition(option) {
      let grpItem;
      switch (option.name) {
        case CONDITION_TYPE.INTERACTION_DATE:
          {
            const queryString = `LastActive=""`;
            let qPrams = this.getQueryDetails(queryString) || {};
            grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
            grpItem.q = queryString;
            break;
          }
        case CONDITION_TYPE.LAST_REPLY_DATE:
          {
            const queryString = `user_lastreply_time=""`;
            let qPrams = this.getQueryDetails(queryString) || {};
            grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
            grpItem.q = queryString;
            break;
          }
        case CONDITION_TYPE.INTERACTION_TIME:
          {
            const queryString = `LastActiveTimestamp<""`;
            let qPrams = this.getQueryDetails(queryString) || {};
            grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
            grpItem.q = queryString;
            break;
          }
        case CONDITION_TYPE.TALKED_WITH_AGENT: {
          const queryString = `0 in unnest(agent_id)`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.INTERACTED_WITH_CHANNEL:
        case CONDITION_TYPE.INTERACTION_CHANNEL: {
          const queryString = `platform=""`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }

        case CONDITION_TYPE.ENGAGED_WITH_BOT_FLOW: {
          const queryString = `0 in unnest(bots)`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.DLR_STATUS: {
          const queryString = `conversation_id = {"operand":"in","value":{"table":"broadcast_dlr","args":[]}}`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams, broadcastId: null, statuses: [], broadcastSearchTerm: '', broadcastSearchResults: [], showBroadcastDropdown: false, broadcastSearchLoading: false };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.BROADCAST_INTERACTION_STATUS: {
          const queryString = `broadcast_interaction_status = {"operand":"in","value":{"table":"jumper_event_template","args":[]}}`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { 
            ...{ q: queryString, yetToSaveRow: true }, 
            ...qPrams, 
            broadcastId: null, 
            broadcastElements: [],
            selectedElement: null, // Keep for backwards compatibility
            selectedElements: [], // New multi-select property
            selectedButtons: [],
            availableButtons: [],
            templateIds: [], // Keep for backwards compatibility
            broadcastSearchTerm: '', 
            broadcastSearchResults: [], 
            showBroadcastDropdown: false, 
            broadcastSearchLoading: false,
            broadcastDataLoading: false
          };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.MARKETING_OPT_IN_STATE: {
          const queryString = `{"key":"marketing_opt_in_state","operand":"in","value":[]}`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams, statuses: [] };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.NAME: {
          const queryString = `user_name = ""`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.EMAIL: {
          const queryString = `user_email = ""`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.NUMBER: {
          const queryString = `user_mobilenumber = ""`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.GENDER: {
          const queryString = `user_gender = ""`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.TAGS: {
          const queryString = `"null" in unnest(tags)`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams };
          grpItem.q = queryString;
          break;
        }
        case CONDITION_TYPE.CUSTOM_FIELD: {
          const queryString = `"null" in unnest(custom_fields)`;
          let qPrams = this.getQueryDetails(queryString) || {};
          grpItem = { ...{ q: queryString, yetToSaveRow: true }, ...qPrams, value: ':' };
          grpItem.q = queryString;
          break;
        }
        default:
          break;
      }
      this.addNewCondition(grpItem);
    },
    addNewCondition(grpItem) {
      this.$nextTick(() => {
        // add or condition to group
        if (this.groupIndexToAddCondition != null && this.conditionGroups[this.groupIndexToAddCondition]) {
          let groupToAddItem = this.conditionGroups[this.groupIndexToAddCondition];
          groupToAddItem.push(grpItem);
          return;
        } else {
          const newGroup = [grpItem];
          this.conditionGroups.push(newGroup);
        }
      });

      // // get last group
      // const lastGroup = this.conditionGroups[this.conditionGroups.length - 1];

      // // check if last group is first group or only one group is available
      // let isFirstCondition = false
      // if (lastGroup?.length == 1 && lastGroup[0].q.includes('pageid')) {
      //   isFirstCondition = true;
      // }

      // if (this.conditionGroups.length && !isFirstCondition) {
      //   // add item in last group
      //   let lastGroup = this.conditionGroups[this.conditionGroups.length - 1];
      //   lastGroup.push(grpItem);
      //   this.conditionGroups[this.conditionGroups.length - 1] = lastGroup;
      // } else { 
      //   // create new group if first group is with channel or no group is added yet
      //   const newGroup = [grpItem];
      //   this.conditionGroups.push(newGroup);
      // }
    },
    onclickAddCondition($event, gIndex) {
      const el = $event.target;
      const viewportOffset = el.getBoundingClientRect();
      const menuWidth = document.getElementById('app-menu')?.clientWidth || 0;
      const top = viewportOffset.top + viewportOffset.height;
      const left = viewportOffset.left - menuWidth;
      const width = viewportOffset.width;
      this.groupIndexToAddCondition = gIndex;
      this.$emit('clickedOnAddCondition', { actionMenuPosition: { top, left, width } });
    },
    async onComponentLoad() {
      this.loadingPrerequisite = true;
      await this.fetchConditionOptions();
      this.loadingPrerequisite = false;
      this.socialChannels = this.channels.filter(item => {
        return this.socialPlatformConnectedArray.includes(item.id);
      }).map(obj => {
        return {
          id: obj.id,
          value: obj.name
        };
      });
    },
    setDefaultConditions() {
      const channelId = this.editBroadcast?.channel ? this.editBroadcast.channel : this.socialChannels[0]?.id;
      if( channelId ) {
        let queryString = "";
        if (this.selectedSocialPageId) {
          queryString += `platform="${channelId}"&&pageid="${this.selectedSocialPageId}"`;
        } else {
          queryString = `platform="${channelId}"`;
        }
        queryString += `&&marketing_opt_in_state IN (1)`;
        this.oldVersionQueryHandler(queryString);
      }
    },
    removeCondition(e, gIndex, cIndex) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      
      this.$nextTick(() => {
        if (this.conditionGroups[gIndex]) {
          this.conditionGroups[gIndex].splice(cIndex, 1);

          // if no condition left in group then remove group
          if (this.conditionGroups[gIndex].length == 0) {
            this.conditionGroups.splice(gIndex, 1);
          }
        }
      });
      return false;
    },
    async fetchCustomTags() {
      try {
        this.tagsLoading = true;
        this.tags = await queryClient.ensureQueryData(customerTagsQueryOptions);
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.tagsLoading = false;
      }
    },
    async fetchConditionOptions() {
      try {
        this.loading = true;
        let [botsData, agentsData] = await Promise.all([
          queryClient.ensureQueryData(botsQueryOptions()),
          queryClient.ensureQueryData(teamMembersQueryOptions),
        ]);

        if (botsData && botsData.length)
          this.allBots = botsData.filter(
          (e) => e.active
        );
        
        if (agentsData && agentsData.length) {
          this.allAgents = agentsData;
          this.agents = this.allAgents.map(obj => {
            return {
              id: obj.id,
              value: obj.name
            };
          });
        }
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger", });
      } finally {
        this.loading = false;
      }
    },
    validateConditions() {
      let isValid = true;
      this.conditionGroups.forEach((group) => {
        if (!isValid) {
          return;
        }

        group.forEach((condition) => {
          if (!isValid) {
            return;
          }
          if (["bots"].includes(condition.key)) {
            if ([0, "", null, "0", undefined, "undefined", "null"].includes(condition.value)) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: `Enter valid value for ${condition.condition_type}`, type: "danger", });
            }
          } else if (condition.key == "custom_fields") {
            if ([0, "", null, "0", undefined, "undefined", "null"].includes(condition.value) || !condition.value.includes(":")) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: `Enter valid value for ${condition.condition_type}`, type: "danger", });
            }
          } else if (condition.key === "conversation_id" || condition.condition_type === CONDITION_TYPE.DLR_STATUS) {
            if (!condition.broadcastId) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: "Please select a broadcast", type: "danger" });
            } else if (!condition.statuses?.length) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: "Please select at least one status", type: "danger" });
            }
          } else if (condition.key === "broadcast_interaction_status" || condition.condition_type === CONDITION_TYPE.BROADCAST_INTERACTION_STATUS) {
            if (!condition.broadcastId) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: "Please select a broadcast", type: "danger" });
            } else if (!condition.selectedElements?.length) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: "Please select at least one element", type: "danger" });
            } else if (!condition.selectedButtons?.length) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: "Please select at least one button", type: "danger" });
            }
          } else if (condition.key === "marketing_opt_in_state" || condition.condition_type === CONDITION_TYPE.MARKETING_OPT_IN_STATE) {
            if (!condition.statuses?.length) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: "Please select at least one status", type: "danger" });
            }
          } else {
            if ([0, "", null, "0", undefined, "undefined", "null"].includes(condition.value?.trim()) && condition.operator != 'is null' ) {
              isValid = false;
              useUIStore().updateToast({ open: true, message: `Enter valid value for ${condition.condition_type}`, type: "danger", });
            }
          }

        });

      });
      return isValid;
    },
    async onBroadcastSearch(condition) {
      //per-condition search state
      if (!condition.broadcastSearchTerm) condition.broadcastSearchTerm = '';
      if (!condition.broadcastSearchResults) condition.broadcastSearchResults = [];
      if (!condition.hasOwnProperty('showBroadcastDropdown')) condition.showBroadcastDropdown = false;
      if (!condition.hasOwnProperty('broadcastSearchLoading')) condition.broadcastSearchLoading = false;
      if (condition.broadcastSearchTimeout) { clearTimeout(condition.broadcastSearchTimeout); }
      const term = condition.broadcastSearchTerm;
      // If broadcastId is already set and user hasn't changed the text, skip search
      if (condition.broadcastId && condition._lastSelectedName === term) {
        return;
      }
      if (!term || term.length < 2) {
        condition.broadcastSearchResults = [];
        condition.showBroadcastDropdown = false;
        condition.broadcastSearchLoading = false;
        // Clear the broadcast selection when search term is cleared
        condition.broadcastId = null;
        return;
      }
      condition.showBroadcastDropdown = true;
      condition.broadcastSearchLoading = true;
       // Get channel param from "Interacted with Channel" filter condition
      let channel = '';
      // Find the platform/channel condition in conditionGroups
      for (const group of this.conditionGroups) {
        const platformCondition = group.find(c => c.key === 'platform' || c.condition_type === CONDITION_TYPE.INTERACTION_CHANNEL || c.condition_type === CONDITION_TYPE.INTERACTED_WITH_CHANNEL);
        if (platformCondition && platformCondition.value) {
          channel = platformCondition.value;
          break;
        }
      }
      // Fallback to editBroadcast channel or first socialChannel if not found
      if (!channel) {
        channel = this.editBroadcast?.channel || (this.socialChannels[0]?.id || '');
      }

      condition.broadcastSearchTimeout = setTimeout(async () => { // debouncing the search API call
        try {
          const response = await apiInterceptor.get(environment("VUE_APP_API_URL") + "broadcasts/v1/broadcasts/s/", { params: { name: term, channel: channel } });
          if (Array.isArray(response)) {
            condition.broadcastSearchResults = response.map(broadcast => ({ value: broadcast.id, title: broadcast.name }));
          } else {
            condition.broadcastSearchResults = [];
          }
          condition.showBroadcastDropdown = true;
        } catch (err) {
          condition.broadcastSearchResults = [];
          condition.showBroadcastDropdown = true;
        } finally {
          condition.broadcastSearchLoading = false;
        }
      }, 400);
    },
    async onSelectBroadcast(item, condition) {
      condition.broadcastId = item.value;
      condition.broadcastSearchTerm = item.title;
      condition._lastSelectedName = item.title;
      condition.showBroadcastDropdown = false;
      
      if (condition && (condition.condition_type === CONDITION_TYPE.DLR_STATUS || condition.condition_type === CONDITION_TYPE.BROADCAST_INTERACTION_STATUS)) {
        this.updateBroadcastSelection({ selectedValue: item.value }, condition);
        
        // Fetch broadcast data for interaction status condition
        if (condition.condition_type === CONDITION_TYPE.BROADCAST_INTERACTION_STATUS) {
          this.loadingBroadcastDetails = true;
          try {
            await this.fetchBroadcastData(item.value, condition);
          } finally {
            this.loadingBroadcastDetails = false;
          }
        }
      }
    },
    handleClickOutsideBroadcastDropdown(e) {
      const dropdown = this.broadcastDropdownRef;
      if (dropdown && dropdown.$el && typeof dropdown.$el.contains === 'function') {
        if (!dropdown.$el.contains(e.target)) {
          this.showBroadcastDropdown = false;
        }
      } else if (dropdown && typeof dropdown.contains === 'function') {
        if (!dropdown.contains(e.target)) {
          this.showBroadcastDropdown = false;
        }
      }
    },
    onBroadcastClear(condition) {
      // Clear all broadcast-related data when clear button is clicked
      condition.broadcastSearchTerm = '';
      condition.broadcastSearchResults = [];
      condition.showBroadcastDropdown = false;
      condition.broadcastSearchLoading = false;
      condition.broadcastId = null;
      
      // For broadcast interaction status, also clear element and button selections
      if (condition.condition_type === CONDITION_TYPE.BROADCAST_INTERACTION_STATUS) {
        // Use Vue.set to ensure proper reactivity for all properties
        this.$set(condition, 'broadcastElements', []);
        this.$set(condition, 'selectedElement', null); // Keep for backwards compatibility
        this.$set(condition, 'selectedElements', []); // New multi-select property
        this.$set(condition, 'selectedButtons', []);
        this.$set(condition, 'availableButtons', []);
        this.$set(condition, 'templateIds', []); // Keep for backwards compatibility
        
        // Also trigger a force update to ensure UI updates
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
      
      if (condition.broadcastSearchTimeout) {
        clearTimeout(condition.broadcastSearchTimeout);
        condition.broadcastSearchTimeout = null;
      }
    },
  },
};
</script>

<style>
.selectOptionsSegment .alert-wrapper {
  background: #e5e5e5;
  --max-width: 316px;
  --width: 316px;
}
</style>

<style scoped>

.full-width {
  width: 100% !important;
}

.group {
  position: relative;
  border-radius: 5px;
  overflow: visible;
}

.group:nth-last-child(2) {
  margin-bottom: 0px;
}

.group-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--background-primary);
  z-index: 99999;
  width: 100%;
  margin: 25px 0;
}

.group-divider span {
  display: flex;
  position: absolute;
  background: var(--background-primary);
  font-size: 14px;
  border-radius: 5px;
  padding: 8px;
  color: var(--gray-04);
  margin-left: 20px;
}
.segments-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}

.groupDragElement {
  position: absolute;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  background: var(--background-primary);
  z-index: 999;
}

.emptyGroup .groupDragElement {
  display: none;
}

.emptyGroup.active .groupDragElement {
  display: flex;
}

.row-divider {
  position: relative;
  z-index: 999;
  padding: 15px 0px;
  font-size: 14px;
}

.row-divider .condition-text {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: -6px;
}

.row-divider .condition-text div {
  background: var(--background-primary);
  padding: 0 10px 2px 10px;
  border-radius: 5px;
}

.condition-dropdown-row {
  border-bottom: 1px solid var(--background-primary);
  padding-bottom: 20px;
}

.segment-list-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 10px;
}

.segment-row {
  position: relative;
  display: flex;
  column-gap: 10px;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.segment-row.lastRow {
  border-bottom: none;
}

.emptyGroup {
  height: 10px;
  border: none;
}

.emptyGroup.active {
  height: 40px;
}

.segment-name,
.segment-condition,
.segment-title {
  flex: 1;
  white-space: nowrap;
  border-radius: 5px;
  height: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.segment-name.hasItem {
  display: flex;
  justify-content: center;
}

.segment-title {
  padding: 0;
}

.segment-name {
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  cursor: move;
  height: 40px;
}

.static-condition {
  background: var(--background-primary);
  width: 55px;
  padding: 10px;
  border-radius: 5px;
}

.segment-name span,
.segment-condition span,
.segment-title span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}

.segment-condition {
  max-width: 100%;
}
.auto-complete-container {
  width: 100%;
}

.segment-value ion-select, .segment-value .date-time {
  width: 100%;
  padding: 10px;
  --date-time-button-color: var(--ion-color-primary-contrast);
}

.auto-complete-container {
  --background: var(--background-primary);
  background: var(--background-primary);
  width: 100%;
  border-radius: 5px;
}

span.ion-select,
span.ion-input {
  background: var(--background-primary);
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 61px;
  min-height: 40px;
  padding: 5px 0;
}

span.ion-select span,
span.ion-input span {
  max-width: 100%;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0px 5px;
}

.no-condition-value {
  padding-right: 25px;
}

.btm-remove-segment {
  cursor: pointer;
}

.addBtn {
  color: var(--purple);
  border: 1px solid var(--purple);
  border-radius: 5px;
  height: 35px;
  padding: 0 4px;
}

.table-row {
  border-bottom: 1px solid #EDEDED;
  margin: 21px 0px 21px 17px;
}

.table-row:last-child {
  border-bottom: 0px;
}

.orderSubtitle {
  font-size: 14px;
  font-weight: 400;
  font-family: Helvetica, Arial, sans-serif;
  color: var(--ion-color-grey);
  margin-top: 25px;
}

.radio-bttns {
  margin-right: 10px;
}

.btn-add-condition-wrapper, .btn-or-condition-wrapper {
  border: 1px solid var(--purple);
  border-radius: 5px;
  overflow: hidden;
  margin-top: 20px;
}

.btn-or-condition-wrapper {
  margin: 20px 0px 10px 0px ;
}

.btn-add-condition, .btn-or-condition {
  background: var(--white);
  color: var(--purple);
  height: 40px;
}
.infoBanner .panel.panel-default {
  width: 100%;
  display: block;
  position: relative;
  background-color: #E1ECFF;
  overflow: hidden;
  border-radius: 5px;
  border: none;
  box-shadow: none;
}

.panel-body {
  padding: 15px;
}

.panel-text {
  font-size: 16px;
  color: #262626;
  padding-bottom: 10px;
}

ion-button.btn-refresh {
  --box-shadow: none;
  color: #262626;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.infoBanner .panel .panel-body {
  border-left: 3px var(--primary-theme-color, #3d39b9) solid;
}

.infoBanner.success .panel.panel-default {
  background-color: #eafdf2;
}

.model-sections {
  background: var(--ion-color-white);
  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 15px;
  margin-bottom: 20px;
}

.orderSubtitle {
  font-size: 14px;
  font-weight: 400;
  color: var(--ion-color-grey);
  margin-top: 25px;
}

.tooltip_container .tooltip_text.left {
  top: 5%;
}

@media only screen and (max-width: 768px) {
  .conditionsEdit {
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 480px) {
  .segment-row {
    flex-direction: column;
    position: relative;
    align-items: flex-start;
    row-gap: 20px;
  }
  .segment-name{
    width: 100%;
    flex: 40px 1 0;
  }
  .static-condition {
    width: 100%;
    text-align: center;
  }
  .segment-condition {
    width: 100%;
    flex: 40px 1 0;
    max-width: 100%;
  }
  .date-time-dropdown {
    width: 100%;
    flex: 40px 1 0;
  }
  .segment-title{
    width: 100%;
    flex: 40px 1 0;
  }
  .segment-title ion-button{
    margin: 0;
  }
  .segment-value{
    width: 100%;
    flex: 40px 1 0;
  }
  ion-select::part(icon) {
    position: absolute;
    right: 0;
  }
}

.element-container {
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: var(--ion-color-black);
  padding-left: 15px;
  padding-bottom: 5px;
}

.upload-img {
  max-width: 453px;
}

.model-sections {
  background: var(--ion-color-white);
  border-radius: 5px;
  margin-bottom: 10px;
  position: relative;
  padding: 10px;
  width: fit-content;
}

.inpt-container {
  width: 360px;
  margin: 0px 30px 10px 46px;
}

.addRow {
  margin-top: 0;
  margin-bottom: 0;
}

.addRow:hover {
  border: 2px #881fff dashed;
}

.addNew {
  max-width: 450px;
  width: 100%;
}

.addNew.complete {
  border-bottom: 2px #eee dashed;
}

.textarea-box {
  width: 450px;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 8px 8px 0px 0px;
  background: #eaecf3;
  display: inline-block;
}

.img-block {
  border-radius: 5px;
  border: 2px #eee dashed;
  width: 450px;
  display: inline-block;
}

.jinput {
  background-color: #ffffff;
}

@media only screen and (max-width: 760px) {

  .model-sections,
  .element-container {
    width: calc(100% - 40px);
  }

  .addNew {
    max-width: 100%;
    margin-left: 0px;
  }

  .upload-img {
    max-width: 100%;
    margin-left: 0px;
  }

  .textarea-box {
    width: 100%;
  }

  .img-block {
    width: 100%;
  }

  .inpt-container {
    margin: 0px 10px 10px 10px;
    width: 95%;
  }

  .jinput {
    width: 98%;
  }
}

.tooltip_container .tooltip_text.left {
  top: 5%;
  z-index: 999;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.segment-filter-section{
  padding: 15px 20px;
  border-radius: 5px;
  border: 1px solid var(--background-primary);
  overflow: visible;
}
.deleteBttn{
  --border-color: var(--orange);
  --padding-top: 10px;
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-bottom: 10px;
}
.broadcast-search-dropdown {
  position: relative;
  width: 100%;
  background: var(--background-primary) !important;
  z-index: 100;
  border-radius: 5px;
}
.broadcast-dropdown-list {
  position: absolute;
  z-index: 9999;
  background: #fff !important;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  left: 0;
  top: 42px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
}
.broadcast-dropdown-item {
  cursor: pointer;
  padding: 10px 12px;
  font-size: 14px;
  color: var(--black);
  transition: background 0.15s;
  &:hover {
    background: var(--purple-opac);
    color: var(--purple);
  }
  &.loading, &.empty {
    cursor: default;
    color: var(--gray-04);
    display: flex;
    align-items: center;
    gap: 8px;
    &:hover {
      background: transparent;
      color: var(--gray-04);
    }
  }
}
/* Ensure parent containers do not clip the dropdown */
.segment-title.broadcast-value,
.segment-row.marginBottom {
  overflow: visible !important;
  position: relative;
  z-index: 10;
}
.segment-title.segment-value {
  overflow: visible !important;
}
.group.segment-filter-section.singleItem {
  overflow: visible !important;
  z-index: 100;
}
.vivid-input, .vivid-select  {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
}
.icon-disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
